'use client';
import { LocaleType } from '@/utils/constants';
import { EPlatform } from '@/utils/enums/platform-enum';
import { apartmentValidator, getErrorTranslationKey } from '@/utils/form-rule';
import { Box } from '@mui/material';
import { cva } from 'class-variance-authority';
import { useLocale, useTranslations } from 'next-intl';
import { useContext, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { AddressFormData } from '.';
import Input from '../Form/FormInput';
import { ResponsiveContext } from '../Responsive/ResponsiveProvider';
import WapOnly from '../Responsive/WapOnly';

const FormItemApartment = ({ formData }: { formData: UseFormReturn<AddressFormData> }) => {
  const t = useTranslations('address');
  const tValidation = useTranslations('components.address.validation');
  const { deviceType } = useContext(ResponsiveContext);
  const [apartment, setApartment] = useState<string>(formData.getValues('apartment'));
  const locale = useLocale() as LocaleType;
  const apartmentPlaceholderStyle = cva(
    'absolute top-[8px] left-[106px] h-[46px] f14 right-[16px] flex items-center text-auxiliary-dark-gray pointer-events-none',
    {
      variants: {
        locale: {
          fr: 'left-[120px]',
          en: 'left-[106px]',
          de: 'left-[106px]',
          es: 'left-[106px]',
          it: 'left-[106px]',
          pt: 'left-[106px]',
          fi: 'left-[106px]',
          nl: 'left-[106px]',
        },
      },
      defaultVariants: {
        locale: 'en',
      },
    },
  );
  formData.watch((value) => {
    setApartment(value.apartment);
  });
  return (
    <Box
      sx={{
        width: '100%',
        position: 'relative',
        '&:focus-within .FormItemApartmentPlaceholder': {
          display: 'none',
        },
      }}
    >
      <Input
        name="apartment"
        label={[EPlatform.WEB].includes(deviceType) ? t('apartmentWebLabel') : t('apartment')}
        slotProps={{
          input: {
            inputProps: {
              maxLength: 20,
            },
          },
        }}
        control={formData.control}
        rules={{
          validate: () => {
            const errorCode = apartmentValidator(formData.getValues('apartment'));

            if (errorCode) {
              const translationKey = getErrorTranslationKey(errorCode);
              return translationKey ? tValidation(translationKey) : 'Validation error';
            }
            return true;
          },
        }}
      />
      <WapOnly>
        {!apartment && (
          <div className={`FormItemApartmentPlaceholder ${apartmentPlaceholderStyle({ locale })}`}>
            {t('apartmentPlaceholder')}
          </div>
        )}
      </WapOnly>
    </Box>
  );
};

export default FormItemApartment;
